
import { FC } from 'react';

const BASE_CLASS = 'button-more-subscriptions';

type TButtonMoreSuscriptionsProps = {
    text: string;
}

export const ButtonMoreSubscription: FC<TButtonMoreSuscriptionsProps> = ({
    text
}) => {
    return (
        <div className={BASE_CLASS}>
            {text}
        </div>
    )
}